export enum Alignment {
    top = 'top',
    left = 'left',
    right = 'right',
    bottom = 'bottom',
}

export enum DropdownBoxSize {
    fullSize = 1,
    halfSize = 2,
    smallSize = 3,
}

export interface DropdownMenuOptions {
    id: string;
    name: string;
    docTipKey: string;
}

export interface TipDropdownMenuOptions {
    id: string;
    name: string;
    tipKey?: string;
}

export interface DocumentDisplayInfo {
    label: string;
    value: string;
    type: string;
    [key: string]: string;
}

export interface OptionValue {
    label: string;
    value: string;
}

export interface SharedComponentAEM {
    [key: string]: string;
}
